// TODO - remove this once all customers upgrade, or replace this with an API
export const FEATURES_SUPPORT_VERSIONS = {
  DB_QUERY_ON_RESTORE_ACCOUNT: '1.3.0',
  SOURCE_ACCOUNT_METRICS: '1.5.4',
  RESTORE_ACCOUNT_METRICS: '1.5.11',
  GCP_RESTORE_ACCOUNT_CONNECTIVITY_CONFIG: '1.2.2',
  GCP_RESTORE_ACCOUNT_RESTORE_ACCOUNT: '1.2.3',
  GCP_START_INSTANCE_AFTER_RESTORE: '1.2.4',
  MONGO_ATLAS_ONBOARDING: '1.10.4',
  RDS_RESTORE_PASSWORD_MANAGEMENT: '1.9.4',
};
